/** Transactional inbox data — always refetch; do not show stale cache while fetching */
export const INBOX_TRANSACTIONAL_QUERY_OPTIONS = {
  staleTime: 0,
  refetchOnMount: "always" as const,
  refetchOnWindowFocus: false,
};

/** Semi-static content (email MIME) — safe to cache */
export const INBOX_STATIC_QUERY_OPTIONS = {
  staleTime: 10 * 60 * 1000,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
};
